
import Messages2 from "../../../assets/duotone/Messages2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Messages2Icon({ className, dataTestid = "Messages2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Messages2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
